// ---------------------------------------------------------------------------
// logo — animated owl video load/fallback.
// The logo video is hosted remotely; if it (or its sources) fail to load,
// mark the container `--failed` so the CSS poster still-image shows instead.
// Also nudges autoplay, which some browsers defer.
// ---------------------------------------------------------------------------

export const initLogo = (): void => {
	const videos = document.querySelectorAll<HTMLVideoElement>('video.logo__animation-video');
	for (const video of videos) {
		const container = video.closest('.logo__animation-container');
		const fail = (): void => container?.classList.add('logo__animation-container--failed');

		video.addEventListener('error', fail);
		for (const source of video.querySelectorAll('source')) {
			source.addEventListener('error', fail);
		}

		const playback = video.play?.();
		if (playback && typeof playback.catch === 'function') {
			playback.catch(() => {
				/* autoplay blocked — poster remains visible */
			});
		}
	}
};
